export enum EmailSendStatus {
  Unsent,
  Sending,
  Successful,
  Failed
}
